<template lang="pug">
  section.export
    .container-fluid.overflow-auto
      .row.q-col-gutter-md.items-center
        .col-auto.flex.items-center
          md-button.md-primary.cta(@click='$emit("reset-pressed")')
            md-icon.icon cached
            span Reset
        .col-auto.flex.items-center.q-mr-md
          md-button.md-primary.cta(@click='$emit("export-pressed")')
            md-icon.icon keyboard_capslock
            span Export
        .col-lg-4
          md-field
            label {{ placeholder }}
            md-input(v-model="docId")
        .col-4.flex.items-center
          q-btn.q-mr-md(flat color="primary" dense rounded icon="delete" @click="resetDocId")
          q-btn(color="primary" label="Search" @click='$emit("doc-search", docId)')
</template>

<script>
export default {
  name: 'DocExport',

  props: {
    placeholder: {
      type: String,
      default: 'Doc ID',
    },
  },

  data() {
    return {
      docId: '',
    };
  },
  methods: {
    resetDocId() {
      this.docId = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.export {
  margin-bottom: 1rem;
  border-radius: 4px;
  background-color: #f5f5f5;

  .cta {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0;

    span {
      font-size: 12px;
    }
  }

  .icon {
    font-size: 16px !important;
  }
}
</style>
